import React from 'react';
import {Field, reduxForm} from "redux-form";
import {connect} from "react-redux";
import moment from "moment";
import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from '@material-ui/core/Button';


// Integrating redux form and material UI

const renderTextField = ({
                           input,
                           meta: {touched, error},
                           defaultValue,
                           helperText,
                           ...custom
                         }) => (
  <TextField
    error={!!(touched && error)}
    helperText={(touched && error) ? error : helperText}
    defaultValue={defaultValue}
    {...input}
    {...custom}
  />
);


// Field level validations

const required = value => (value ? undefined : 'Required');
const isFutureDate = value => (moment(value) > moment() ? undefined : 'Please choose a future date');


// Form level validations

const validate = values => {
  return {}
};

function PostShiftForm(props) {
  const {classes, handleSubmit, jobs, managers, submitting, error, valid} = props;

  return (
    <form className={classes.form} onSubmit={handleSubmit}>
      <div className={classes.fieldSet}>
        <Typography className={classes.title} variant={'subheading'}>Required</Typography>
        <Field
          name="manager"
          component={renderTextField}
          label="Manager"
          select
          validate={[required]}
          className={classes.fieldGroup}
          SelectProps={{
            native: true,
          }}
        >
          <option disabled value={null}/>
          {(managers) ? managers.map(manager => (
            <option key={manager.id} value={manager.id}>
              {manager.name}
            </option>
          )) : null}
        </Field>
        <Field
          className={classes.fieldGroup}
          name="job"
          component={renderTextField}
          select
          label='Job Type'
          validate={[required]}
          SelectProps={{
            native: true,
          }}
        >
          <option disabled value={null}/>
          {(jobs) ? jobs.map(job => (
            <option key={job.id} value={job.id}>
              {job.name}
            </option>
          )) : null}
        </Field>
        <Field
          name='date'
          label='Date'
          component={renderTextField}
          className={classes.fieldGroup}
          type='date'
          validate={[required, isFutureDate]}
          InputLabelProps={{
            shrink: true,
          }}
          helperText='Want to add more dates? Email hsuken@singleshift.sg'
        />
        <Field
          name='startTime'
          label='Start Time'
          component={renderTextField}
          className={classes.fieldGroup}
          type='time'
          validate={[required]}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 600, // 10 min
          }}/>
        <Field
          name='endTime'
          label='End Time'
          component={renderTextField}
          className={classes.fieldGroup}
          type='time'
          validate={[required]}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 600, // 10 min
          }}/>
        <Field
          name="wage"
          component={renderTextField}
          className={classes.fieldGroup}
          label='Hourly Wage'
          validate={[required]}
          type='number'
          InputProps={{
            startAdornment: <InputAdornment position="start">SGD</InputAdornment>,
          }}
        >
        </Field>
        <Field
          className={classes.fieldGroup}
          name="required_pros"
          component={renderTextField}
          label='Pros Required'
          type='number'
          validate={[required]}
        >
        </Field>
      </div>
      <div className={classes.fieldSet}>
        <Typography className={classes.title} variant={'subheading'}>Optional</Typography>
        <Field
          className={classes.fieldGroup}
          name='address'
          label='Address'
          component={renderTextField}
          helperText='e.g. City Hall (15 Beach Rd, 189677)'
        />
        <Field
          className={classes.fieldGroup}
          name='attire'
          label='Attire'
          component={renderTextField}
        />
        <Field
          className={classes.fieldGroup}
          name='duties'
          label='Duties'
          component={renderTextField}
          helperText='What will they be doing?'
        />
        <Field
          className={classes.fieldGroup}
          name='comments'
          label='Comments'
          component={renderTextField}
          helperText='Anything else you want to mention?'
        />
        <Field
          className={classes.fieldGroup}
          name='event'
          label='Event Name'
          component={renderTextField}
          helperText='If this is an event, what is the name of the event?'
        />
      </div>
      <Button disabled={!valid || submitting}
              variant="raised" color="primary" type='submit'>
        Review Shift
      </Button>
    </form>
  )
}

const styles = (theme) => ({
  form: {
    maxWidth: '400px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  fieldSet: {
    marginBottom: theme.spacing.unit * 4,
  },
  fieldGroup: {
    width: '100%',
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    justifyContent: 'space-between',
    display: 'flex',
  },
  wrapper: {
    position: 'relative',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    display: 'inline-block',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  title: {
    fontWeight: 'bold',
  },
});


export default connect((state) => ({
  initialValues: {
    date: moment().add(2, 'days').format('YYYY-MM-DD'),
    startTime: '08:00',
    endTime: '12:00',
    wage: '10.00',
    required_pros: '1',
    manager: state.managers && state.managers.items && state.managers.items[0].id,
    job: state.jobs && state.jobs.items && state.jobs.items.filter(job => job.name === 'Server')[0].id,
    address: state.business.item && state.business.item.address,
  },
}))(reduxForm({
  form: 'createShift',
  enableReinitialize: true,
  validate
})(withStyles(styles)(PostShiftForm)));



// WEBPACK FOOTER //
// ./src/parts/PostShiftForm.js